import type { MonogramItem } from './interfaces';

/**
 * Partial monograms are rejected downstream: `getConfigurationDetails` marks them invalid
 * (blocking add-to-bag) and `addToBag` dereferences a `colors[0]` that does not exist.
 */
export const isMonogramDraftComplete = (draft: MonogramItem | undefined, hasError: boolean): boolean =>
  !!draft?.initials?.length && !hasError && !!draft.colorId && !!draft.fontStyleId;
